import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { getCountriesUser, useCountryReducer } from "@/main/store/country";
import { getStatusRegister, useStatusRegisterReducer } from "@/main/store/statusRegister";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";

import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import * as S from "./styles";
import { getDefaultOptionDrop, getTranslateByKey } from "@/main/services/utils";

function SectionInfo() {
	const dispatch = useDispatch();
	const countryReducer = useCountryReducer();
	const statusRegisterReducer = useStatusRegisterReducer();
	const {
		control,
		setValue,
		formState: { errors },
	} = useFormContext();
	const optionDefaultCountryDrop = getDefaultOptionDrop(countryReducer.countriesUser.data);

	const isDisabledCountry = () => optionDefaultCountryDrop !== null;

	function getErrorsFieldRfc() {
		const errorTypeRfc = errors.rfc?.type;
		if (errorTypeRfc) {
			if (errorTypeRfc === "minLength") {
				return getTranslateByKey("information.rfcMustHaveAtLeast12Digits", true);
			}
			if (errorTypeRfc === "required") {
				return getTranslateByKey("information.rfcRequired", true);
			}
		}

		return "";
	}

	useEffect(() => {
		dispatch(getCountriesUser());
		dispatch(getStatusRegister());
	}, []);

	return (
		<S.Container>
			<S.HeaderSection>
				<S.HeaderText>{getTranslateByKey("information.bodyshopInformation")}</S.HeaderText>
			</S.HeaderSection>
			<S.AreaForm>
				<KogAutoCompleteControlled
					nameCustom="country"
					label={getTranslateByKey("information.country")}
					control={control}
					disabled={isDisabledCountry()}
					rulesCustom={{ required: true }}
					errorMessageCustom={
						errors.country?.type === "required" ? getTranslateByKey("information.countryRequired", true) : ""
					}
					hasErrorCustom={!!errors.country}
					options={countryReducer.countriesUser.data}
					isLoading={countryReducer.countriesUser.isLoading}
					onChangeCustom={() => {}}
					id="id-registerBodyshop-txt-country"
					autoHighlightCustom={!!optionDefaultCountryDrop}
					setValueCustom={setValue}
				/>
				<KogInputTextControlledNew
					name="companyName"
					label={getTranslateByKey("information.companyName")}
					control={control}
					controllerProps={{ rules: { required: true } }}
					id="id-registerBodyshop-txt-companyName"
					errorMessageCustom={
						errors.companyName?.type === "required" ? getTranslateByKey("information.companyNameRequired", true) : ""
					}
				/>
				<KogInputTextControlledNew
					name="rfc"
					label={getTranslateByKey("information.rfc")}
					control={control}
					inputProps={{ maxLength: 20 }}
					controllerProps={{ rules: { required: true, minLength: 12 } }}
					helperText={getErrorsFieldRfc()}
					error={!!errors.rfc}
					id="id-registerBodyshop-txt-rfc"
				/>
				<KogAutoCompleteControlled
					label={getTranslateByKey("information.status")}
					nameCustom="status"
					valueDefaultKey={String(StatusRegisterEnum.Active)}
					setValueCustom={setValue}
					options={statusRegisterReducer.statusRegister.data}
					isLoading={statusRegisterReducer.statusRegister.isLoading}
					control={control}
					rulesCustom={{ required: true }}
					disabled={true}
					errorMessageCustom={
						errors.status?.type === "required" ? getTranslateByKey("information.statusRequired", true) : ""
					}
					hasErrorCustom={!!errors.status}
					onChangeCustom={() => {}}
					id="id-registerBodyshop-txt-status"
				/>
				<KogInputTextControlledNew
					name="tradeName"
					label={getTranslateByKey("information.tradeName")}
					control={control}
					controllerProps={{ rules: { required: true } }}
					id="id-registerBodyshop-txt-tradeName"
					errorMessageCustom={
						errors.tradeName?.type === "required" ? getTranslateByKey("information.tradeNameRequired", true) : ""
					}
				/>
			</S.AreaForm>
		</S.Container>
	);
}

export default SectionInfo;
